import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { ButtonSingle, ButtonDouble } from "../../../../widget/common/form/Button";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { Col } from "react-bootstrap";
import { ARFContextImport } from "../../../../provider/chats/chats/ARF/ARFContextProvider";
import { useDispatch } from "react-redux";
import { removeAllModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";

const ARButtons = () => {
  const type: number = ResponsiveDeviceType();
  const dispatch = useDispatch();

  const { handleSubmit } = ARFContextImport();

  const handleCancel = () => {
    dispatch(removeAllModal());
    window.history.replaceState(null, "", window.location.pathname);
  };

  return type === 3 ? (
    <div className={`pt-3 ${type === 3 ? "d-center" : ""}`}>
      <ButtonSingle handleClick={handleSubmit} width={250}>
        {AppTranslation.text("submit")}
      </ButtonSingle>
    </div>
  ) : (
    <Col xs={12} md={8}>
      <ButtonDouble
        className="w-100"
        title1="cancel"
        title2="submit"
        handleClick1={handleCancel}
        handleClick2={handleSubmit}
      />
    </Col>
  );
};

export default ARButtons;
